import { packageConstants } from '../constants';

export function packages(state = {}, action) {
  switch (action.type) {
    case packageConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case packageConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case packageConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddPackage(state = {}, action) {
  switch (action.type) {
    case packageConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case packageConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case packageConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetPackage(state = {}, action) {
  switch (action.type) {
    case packageConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case packageConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case packageConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdatePackage(state = {}, action) {
  switch (action.type) {
    case packageConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case packageConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case packageConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}